import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';

@Component({
  selector: 'smart-manage-thing-view',
  templateUrl: './manage-thing-view.component.html',
  styleUrls: ['./manage-thing-view.component.scss','../../platform-color/platform-color.css']
})
export class ManageThingViewComponent implements OnInit {
  @Output() done = new EventEmitter<any>();
  @Input()
  thingInfo: any;

  @ViewChild("closeModalBtn") closeModalBtn: ElementRef;

  thingMGL = null;
  constructor(
    private FarmService: FarmService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    if(this.thingInfo && this.thingInfo.thing_key){
      this.spinner.show();
      let filter = {
        thing_key: this.thingInfo.thing_key
      }
      this.FarmService.getThingMenuMGL(filter).subscribe(res=>{
        if(res.code == 200){
          this.thingMGL = res.data;
        }
        this.spinner.hide();
      })
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (
      changes.thingInfo
    ) {
      this.ngOnInit();
    }
  }

  update(){
    this.spinner.show();
    this.thingInfo = {
      ...this.thingInfo,
      thing_key: this.thingMGL.ThingInfo[0].ThingIdentifier,
      thing_id: this.thingMGL.ThingInfo[0].ThingId,
      thing_token: this.thingMGL.ThingInfo[0].ThingToken, 
      account_id: this.thingMGL.ThingInfo[0].AccountId,
      thing_name:  this.thingMGL.ThingInfo[0].ThingName,
      imei:  this.thingMGL.ThingInfo[0].IMEI,
      thing_secret:  this.thingMGL.ThingInfo[0].ThingSecret,
    }

    this.FarmService.updateThing(this.thingInfo).subscribe(res=>{
      if(res.code == 200){

        this.closeModalBtn.nativeElement.click();
        this.spinner.hide();

        this.done.emit(true);
      }
    })
  }
}
